<template>
    <b-modal
        id="membership-tiers-confirmation-modal" 
        class="custom-modal"
        centered
        hide-header
        body-class="text-center pt-5"
    >
        <template v-if="tier">
            <p class="modal-main-message">Are you sure you want to delete <strong>{{ tier.name }}</strong>?</p>
        </template>

        <div slot="modal-footer">
            <b-btn
                variant="ghost"
                class="mr-1 btn-cancel"
                @click="onCancel"
            >
                Cancel
            </b-btn>

            <b-btn
                variant="primary"
                class="ml-1"
                @click="$emit('click:confirm', tier.uuid)"
            >
                Confirm
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            tier: null
        };
    },
    methods: {
        onCancel() {
            this.tier = null;

            this.$root.$emit(
                "bv::hide::modal",
                "membership-tiers-confirmation-modal"
            );
        }
    }
};
</script>
